import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Button } from '@sololearnorg/sol';

import { LocalizedLink } from '../../../../../../shared/public/LocalizedLink/LocalizedLink';

import s from './SuccessCase.scss';

export interface ISuccessCaseProps {
    logo: string;
    title: string[];
    text: {
        segments: string[];
        boldKeys?: number[];
        onlyDesktop?: boolean;
        onlyMobile?: boolean;
    }[];
    image: string;
    metrics: {
        value: string;
        type: string;
    }[][];
    cta: string;
    link: string;
}

export function SuccessCase({
	logo,
	title,
	text,
	image,
	metrics,
	cta,
	link,
}: ISuccessCaseProps) {
	useStyles(s);
	return (
		<div className="sl-teams-success-case">
			<div className="sl-teams-success-case__logo">
				<img
					id={logo}
					src={`https://blob.sololearn.com/web-assets/${logo}.png`}
					alt={logo}
				/>
			</div>
			<div className="sl-teams-success-case__title">
				{title.map((line, index) => (
					<p key={index}>{line}</p>
				))}
			</div>
			{text.map(
				(
					{
						segments,
						boldKeys,
						onlyDesktop = false,
						onlyMobile = false,
					},
					index,
				) => (
					<div
						className={`sl-teams-success-case__text${onlyDesktop
							? ' sl-teams-success-case__text__only-desktop'
							: ''
						}${onlyMobile
							? ' sl-teams-success-case__text__only-mobile'
							: ''
						}`}
						key={index}
					>
						{segments.map((segment, key) => (
							<span
								key={key}
								className={
									boldKeys?.includes(key)
										? 'sl-teams-success-case__text__bold'
										: ''
								}
							>
								{segment}
							</span>
						))}
					</div>
				),
			)}
			<div className="sl-teams-success-case__body">
				<div className="sl-teams-success-case__image">
					<img
						id={image}
						src={`https://blob.sololearn.com/web-assets/${image}.png`}
						alt={image}
					/>
				</div>
				<div className="sl-teams-success-case__details">
					<div className="sl-teams-success-case__details__content">
						{metrics.map((columns, index) => (
							<div
								className="sl-teams-success-case__details__content__row"
								key={index}
							>
								{columns.map(({ value, type }, key) => (
									<div
										className="sl-teams-success-case__metric"
										key={key}
									>
										<div className="sl-teams-success-case__metric__value">
											{value}
										</div>
										<div className="sl-teams-success-case__metric__type">
											{type}
										</div>
									</div>
								))}
							</div>
						))}
						<div className="sl-teams-success-case__cta">
							<LocalizedLink to={link} target="_blank">
								<Button>{cta}</Button>
							</LocalizedLink>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
